import React from "react"

// Images
import Image1 from "public/images/icons/1.png"

import Wallet from "public/images/icons/wallet2.png"
import Location from "public/images/icons/location.png"
import Clock from "public/images/icons/wall-clock.png"

// Components
import MainCard from "src/components/common/main-card"

// Next Image
import Image from "next/image"

// Mui
import { Grid, Stack, Typography, useTheme } from "@mui/material"

// ---------------------------------------------------------------------------------------------------------------------

const SimplifyBorrowingItems = () => {
  // Use Theme
  const theme = useTheme()

  const items = [
    {
      image: Wallet,
      title: "با ارائه ضامن",
      subTitle: "به همراه یک برگ چک صیادی"
    },
    {
      image: Clock,
      title: "صرفه جویی در زمان",
      subTitle: "کل فرآیندهای گرفتن وام رو با سرعت جت طی کن"
    },
    {
      image: Image1,
      title: "فرایند آنلاین",
      subTitle: "بدون نیاز به رفتن بانک ، فرایندهات رو آنلاین انجام بده"
    },
    {
      image: Location,
      title: "پوشش کل کشور",
      subTitle: "از هر کجای ایران که باشی ، می تونی از شبکه پذیرندگان جت وام به صورت حضوری و آنلاین خرید کنی"
    }
  ]

  return (
    <Grid container spacing={1} sx={{ mt: 3 }}>
      {items?.map((item, index) => (
        <Grid item xs={12} sm={6} md={3} lg={3} xl={3} key={index}>
          <MainCard shadow={0} sx={{ borderRadius: "15px", p: 2.5, minHeight: 320 }}>
            <Stack direction='row' justifyContent='center'>
              <Image width={100} src={item?.image} alt={item.title} />
            </Stack>
            <Stack spacing={3} mt={6}>
              <Typography
                variant='h5'
                sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000000" }}
                textAlign='center'
              >
                {item?.title}
              </Typography>
              <Typography textAlign='center'>{item?.subTitle}</Typography>
            </Stack>
          </MainCard>
        </Grid>
      ))}
    </Grid>
  )
}

export default SimplifyBorrowingItems
